<template>
  <div>
    <div v-if="pod">
      <AccesslinkCommentsForm
        v-bind:pod="pod"
        @outTimeFocus="(time) => $emit('commentTimeFocus', time)"
        @inTimeFocus="(time) => $emit('commentTimeFocus', time)"
      />
    </div>
    <div v-for="comment in getComments" v-bind:key="comment.id">
      <AccesslinkCommentsItem
        v-bind:pod="pod"
        v-bind:comment="comment"
      />
    </div>
  </div>
</template>

<script>
import { useAccesslinkStore } from '@/stores/AccesslinkStore';
import AccesslinkCommentsForm from "./AccesslinkCommentsForm.vue"
import AccesslinkCommentsItem from "./AccesslinkCommentsItem.vue"

export default {
  name: "AccesslinkComments",
  components: {
    AccesslinkCommentsForm,
    AccesslinkCommentsItem,
  },
  emits: ['commentTimeFocus'],
  props: {
    pod: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getComments: function() {
      const accesslinkStore = useAccesslinkStore();
      return accesslinkStore.getComments.filter(comment => comment.podid === this.pod.id);
    }
  }
}
</script>

<style>
</style>
